export const emailValidator = (email: string) => {

	if (email === null || email === undefined || email === '' || email.length > 50)
		return false;
	const regEx = /^([\w.-]{2,})@([a-z\d-]{2,})\.([a-z]{2,})(\.[a-z]{2,3})?$/
	const isValidEmail = regEx.test(email)
	return isValidEmail;

}